
document.addEventListener('DOMContentLoaded', function () {
  var autoTargets = document.querySelectorAll(
    '.product-card, .card-wrapper, .collection-list__item, ' +
    '.rich-text, .banner__content, .featured-collection h2, ' +
    '.announcement-bar, .image-with-text__content'
  );
  autoTargets.forEach(function (el) {
    el.classList.add('hin-fade-up');
  });

  var targets = document.querySelectorAll('.hin-fade-up');
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('hin-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hin-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) { observer.observe(el); });
});
